var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.showOverlay,"color":"blue-grey darken-2","z-index":"1000"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('b',{staticClass:"pt-4 text-h6"},[_vm._v(_vm._s(_vm.loadingMessage))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }